import { render, staticRenderFns } from "./PhysioDetails.vue?vue&type=template&id=86f6bbb2"
import script from "./PhysioDetails.vue?vue&type=script&lang=js"
export * from "./PhysioDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports